import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Floor from "../../Services/floorServices";

function FloorDetails(props) {
  const shopKeeperId = useParams().id;

  const [floor, setFloor] = useState({});
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const getFloor = async () => {
    setLoading(true);
    await Floor.getOne(shopKeeperId)
      .then((data) => {
        console.log("One Floor", data.data);
        setFloor(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getFloor();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>Floor Details</h4>
              <h6>Full details of a floor</h6>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-8 col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div class="bar-code-view">
                    <img src="/assets/img/barcode1.png" alt="barcode" />
                    <a class="printimg">
                      <img src="/assets/img/icons/printer.svg" alt="print" />
                    </a>
                  </div>
                  <div class="productdetails">
                    <ul class="product-bar">
                      <li>
                        <h4>Branch</h4>
                        <h6>{floor.branchId} </h6>
                      </li>
                      <li>
                        <h4>Floor ID</h4>
                        <h6>{floor.id} </h6>
                      </li>
                      <li>
                        <h4>Floor Name</h4>
                        <h6>{floor.name} </h6>
                      </li>
                      <li>
                        <h4>Area</h4>
                        <h6>{floor.area}</h6>
                      </li>
                      <li>
                        <h4>Free Space</h4>
                        <h6>{floor.freeSpace}</h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FloorDetails;
